import languages from '../../app/constants/forum-languages';

export function validateLanguage(language) {
  return languages.includes(language) ? language : 'en';
}
